import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal, SidebarNoticeBox,
} from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import { UserModel } from '@domain-group/realhub-backend-api-types'

import useDeleteAgentModal from './hooks/useDeleteAgentModal'

const MODAL_KEY = 'DeleteAgentModal'

export type ModalCallbacks = {
  closeModal: () => void,
  deleteAgent: (payload: HandleCallbackActionParams) => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const DeleteAgentModal = (props: ModalProps) => {
  const { callbacks, showModal } = props
  const { deleteAgent } = callbacks || {}

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = digObject(modalData, MODAL_KEY, {})
  const { user: initUser } = modalPayload

  const deleteAgentModalPayload = useDeleteAgentModal({ callbacks, user: initUser })
  const {
    callbacks: { selectAgent },
    deleteAgentPayload,
    filteredAgents,
    newAgentId,
    saveEnabled,
    updating,
    user,
  } = deleteAgentModalPayload

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Remove" titleSecondLine="Agent" />

      <SidebarModal.Content>
        <SidebarNoticeBox boxProps={{ variant: 'white' }}>
          <SidebarNoticeBox.Paragraph boxProps={{ marginTop: 'none' }}>
            Please select an agent to transfer {user.full_name}&apos;s campaigns to. Every campaign that this agent is
            assigned to will be assigned to the new agent selected.
            <strong>This action cannot be undone.</strong>
          </SidebarNoticeBox.Paragraph>
        </SidebarNoticeBox>

        <Form>
          <Form.Field direction="column" label="* Transfer Campaigns To">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="newAgentId" value={newAgentId} onChange={e => selectAgent(e.target.value)}>
              <option value="">Please Select...</option>
              {/*
               // @ts-expect-error TS2345 */}
              {filteredAgents.map((user: UserModel) => (
                <option key={user.actable_id} value={user.actable_id}>
                  {user.full_name} - {user.username}
                </option>
              ))}
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          loading={updating}
          onClick={() => deleteAgent(deleteAgentPayload)}
          size="large"
        >
          {saveEnabled ? 'Remove Agent' : 'Complete Fields'}
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <DeleteAgentModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
